import React, { useState } from 'react';
import { Alert, Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import api from '../../api/api';

export default function ClientEvidence({ clientId }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setOpen(true); setData(null); setError(''); setBusy(true);
    try { const result = await api.get(`/client-portal/clients/${clientId}/evidence`); setData(result.data); }
    catch { setError('Не удалось загрузить журнал.'); }
    finally { setBusy(false); }
  };
  const download = () => {
    const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));
    const link = document.createElement('a'); link.href = url; link.download = `client-${clientId}-evidence.json`;
    link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return <>
    <Button onClick={load} variant="outlined">Согласия и действия</Button>
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
      <DialogTitle>Журнал клиента</DialogTitle>
      <DialogContent>
        {busy && <Typography>Загрузка…</Typography>}
        {error && <Alert severity="error">{error}</Alert>}
        {data && <>
          <Alert severity="info">Создание карточки сотрудником не означает согласие клиента. Тестовая оплата не подтверждает поступление денег. IMEI не собирается.</Alert>
          <Typography sx={{ my: 2 }}>Принятия документов: {data.acceptances.length}. Действия: {data.activities.length}. События заказов: {data.deal_events.length}.</Typography>
          {!data.acceptances.length && <Typography>Подтверждений принятия новых документов пока нет.</Typography>}
          {data.acceptances.map(row => <Box key={row.id} sx={{ my: 2, overflowWrap: 'anywhere' }}>
            <Typography fontWeight={700}>Редакция {row.version} · {new Date(row.created_at).toLocaleString('ru-RU')}</Typography>
            <Typography variant="body2">{row.documents.join(', ')} · IP: {row.ip_address || '—'}</Typography>
            <Typography variant="caption">SHA-256: {row.text_hash}</Typography>
          </Box>)}
          {data.activities.map(row => <Box key={row.id} sx={{ my: 1 }}><Typography variant="body2">{new Date(row.created_at).toLocaleString('ru-RU')} · {row.event_type} · {row.ip_address || '—'}</Typography></Box>)}
          <Button onClick={download}>Скачать полный журнал JSON</Button>
        </>}
        <Button onClick={() => setOpen(false)}>Закрыть</Button>
      </DialogContent>
    </Dialog>
  </>;
}
